export default "__VITE_ASSET__DUeY1D_M__"